<template>
  <div id="content-wrapper">
    <div class="container-fluid pb-0">
      <div class="video-block section-padding">
        <div class="row">
          <div class="col-md-8">
            <div class="single-video-left">
              <!-- <h6>&nbsp</h6> -->
              <div class="single-video">
                <video id="player" playsinline controls></video>
              </div>
              <div class="single-video-title box mb-3">
                <h2>{{video_info.title}}</h2>
                <p class="mb-0">
                  <i class="fas fa-eye"></i>
                  {{video_info.updated_at}} views
                  <!-- TODO: need to change to views -->
                </p>
              </div>
              <div class="single-video-info-content box mb-3">
                <h6>Cast:</h6>
                <p>{{video_info.cast}}</p>
                <h6>Category :</h6>
                <p>{{video_info.category}}</p>
                <h6>About :</h6>
                <p>{{video_info.about}}</p>
                <h6>Tags :</h6>
                <p class="tags mb-0">
                  <span v-for="(tag, i) in video_info.tags" v-bind:key="i">
                    <a href="#">{{tag}}</a>
                    <!-- TODO: add search route-link here -->
                  </span>
                </p>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <div class="single-video-right">
              <h6>Recently viewed</h6>
              <div class="row">
                <div class="col-md-12">
                  <Svideoinfocard
                    v-for="(video,i) in sidebar_videoinfos"
                    v-bind:key="i"
                    :video_id="video.id"
                    :title_text="video.title"
                    :image_src="video.thumbnail"
                    :duration="video.duration"
                    :views="video.views"
                    :time_post="video.time_post"
                    :category="video.category"
                  ></Svideoinfocard>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import Plyr from "plyr";
import Hls from "hls.js";
import Svideoinfocard from "../components/svideoinfocard.vue";
import BasicAPIs from "../api/apis";
import uuidv4 from "uuid/v4";

export default {
  name: "PgVideo",
  components: {
    Svideoinfocard
  },
  props: {},
  data: function() {
    return {
      video_info: {},
      sample_video: {
        title: "Sidebar video Test",
        duration: "31:12",
        img: require("../img/v3.png"),
        time_post: "11 Months ago",
        category: "Education",
        views: "1.3M"
      },
      // sidebar_videoinfos: [],
      movie_source: "",
      player: {},
      resdata: {},
      erro_info: "",
      uuid_spec_v: "",
      analysis_result: {}
    };
  },
  computed: {
    v_id() {
      return this.$route.params.id;
    },
    v_duration() {
      return this.player.duration;
    },
    sidebar_videoinfos() {
      return this.$store.state.played_recently.slice(1);
    }
  },
  created() {
    this.uuid_spec_v = uuidv4();
    let vm = this;
    BasicAPIs.getVideo(vm.$route.params.id).then(res => {
      if (res.data.success === true) {
        vm.video_info = res.data.data;
        vm.$store.commit("pushPlayed_recently", vm.video_info);
        vm.movie_source = res.data.data.video;

        var videox = document.querySelector("#player");
        let source_end = vm.movie_source.split(".").slice(-1)[0];
        console.log(source_end);
        if (source_end === "m3u8") {
          if (Hls.isSupported()) {
            var hls = new Hls();
            hls.loadSource(vm.movie_source);
            hls.attachMedia(videox);

            hls.on(Hls.Events.MANIFEST_PARSED, function() {
              console.log("stream video loaded");
            });
          }
        } else if (source_end === "mp4") {
          videox.setAttribute("src", vm.movie_source);
        }
        vm.player = new Plyr(videox);

        // vm.player.on("playing", event => {
        //   console.log(
        //     "clicking vod at " +
        //       event.detail.plyr.currentTime +
        //       " of " +
        //       event.detail.plyr.duration
        //   );
        // });
        let pct_p = 1;
        vm.player.on("timeupdate", event => {
          let current_player = event.detail.plyr;
          let pct = Math.round(
            (100 * current_player.currentTime) / current_player.duration
          );

          if (pct % 5 === 0 && pct > pct_p) {
            BasicAPIs.sendVideoAnalysis({
              Data: {
                ver: 1,
                time: pct,
                source: "noovo",
                video: vm.v_id,
                event_id: vm.uuid_spec_v
              }
            }).then(res => {
              if (res.status === 200) {
                console.log("sent VideoAnalysis successfully at " + pct + "%");
                vm.analysis_result = res.data;
              }
            });
          }
          pct_p = pct;
        });
      } else {
        alert("api error @getVideo");
      }
    });
  },
  mounted() {
    console.log("you're playing " + this.v_id);
    BasicAPIs.clickVideo({ Data: { video: this.v_id } }).then(res => {
      if (res.status === 200) {
        this.resdata = res.data;
        console.log(
          "sent click statistics successfully for video " + this.v_id
        );
      } else {
        this.erro_info = res.data;
      }
    });
  }
};
</script>


<style  lang='scss'>
@import "../css/plyr_.css";

#player {
  width: 100%;
}
</style>